import { Switch, useHistory } from 'react-router-dom'
import { Button, Result, Route } from '../core/components'
import { routesConfig } from '../core/configs/routes'
import { AppLayout } from '../layouts'
import {
  CalendarPage,
  ContractsPage,
  CreateCustomerPage,
  CustomersPage,
  DetailCustomerPage,
  EditOpportunityPage,
  OpportunitiesPage
} from '../pages'
import { CreateContractPage } from '../pages/contracts/create'
import { DetailContractPage } from '../pages/contracts/details'
import { CreateOpportunityPage } from '../pages/opportunities/create'
import { DetailOpportunityPage } from '../pages/opportunities/details'
import { OrderPage } from '../pages/orders'
import { DetailOrder } from '../pages/orders/details/DetailOrder'
import { ServiceOrderPage } from '../pages/serviceOrder'
import { DetailServiceOrder } from '../pages/serviceOrder/details'

export const UserRoutes = () => {
  const history = useHistory()

  return (
    <AppLayout>
      <Switch>
        <Route
          exact
          private
          path={routesConfig.userRoutes}
          redirect={routesConfig.home}
        />
        <Route private exact path={routesConfig.activities.calendar.list}>
          <CalendarPage />
        </Route>
        <Route private exact path={routesConfig.customers.customer.list}>
          <CustomersPage />
        </Route>
        <Route private exact path={routesConfig.customers.customer.create}>
          <CreateCustomerPage />
        </Route>
        <Route
          private
          exact
          path={routesConfig.customers.customer.details + '/:id'}
        >
          <DetailCustomerPage />
        </Route>
        <Route private exact path={routesConfig.oportunities.oportunity.list}>
          <OpportunitiesPage />
        </Route>
        <Route private exact path={routesConfig.oportunities.oportunity.create}>
          <CreateOpportunityPage />
        </Route>
        <Route
          private
          exact
          path={routesConfig.oportunities.oportunity.edit + '/:id'}
        >
          <EditOpportunityPage />
        </Route>
        <Route private exact path={routesConfig.contracts.contract.list}>
          <ContractsPage />
        </Route>
        <Route private exact path={routesConfig.contracts.contract.create}>
          <CreateContractPage />
        </Route>

        <Route
          private
          exact
          path={routesConfig.oportunities.oportunity.details + '/:id/detalhes'}
        >
          <DetailOpportunityPage />
        </Route>

        <Route private exact path={routesConfig.orders.order.list}>
          <OrderPage />
        </Route>

        <Route
          private
          exact
          path={routesConfig.orders.order.details + '/:id/detalhes'}
        >
          <DetailOrder />
        </Route>

        <Route
          private
          exact
          path={routesConfig.ordersOfService.serviceOrder.list}
        >
          <ServiceOrderPage />
        </Route>

        <Route
          private
          exact
          path={
            routesConfig.ordersOfService.serviceOrder.details + '/:id/detalhes'
          }
        >
          <DetailServiceOrder />
        </Route>

        <Route
          private
          exact
          path={routesConfig.contracts.contract.datails + '/:id/detalhes'}
        >
          <DetailContractPage />
        </Route>
        <Route
          private
          path="*"
          component={() => (
            <Result
              status="404"
              title="404"
              subTitle="A página que está tentando acessar não existe!"
              extra={
                <Button
                  type="primary"
                  onClick={() =>
                    history.push(routesConfig.customers.customer.list)
                  }
                >
                  Ir para página inicial
                </Button>
              }
            />
          )}
          exact
        />
      </Switch>
    </AppLayout>
  )
}
